import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

const footerLinks = {
  服务导航: [
    { label: '品牌官网', path: '/' },
    { label: '域名管理', path: '/category/product-service' },
    { label: '安全防护', path: '/category/tech-frontier' },
    { label: '数据分析', path: '/category/product-service' },
  ],
  内容中心: categories.slice(0, 4).map((cat) => ({
    label: cat.name,
    path: `/category/${cat.slug}`,
  })),
  关于我们: [
    { label: '品牌介绍', path: '/about' },
    { label: '联系方式', path: '/about' },
    { label: '常见问题', path: '/' },
    { label: '用户协议', path: '/about' },
  ],
};

export default function Footer() {
  return (
    <footer className="bg-foreground-900 text-background-50">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Brand Column */}
          <div className="lg:col-span-1">
            <Link to="/" className="inline-block no-underline mb-4">
              <span className="text-2xl font-bold font-heading text-white tracking-tight">
                问鼎<span className="text-primary-400">.cc</span>
              </span>
            </Link>
            <p className="text-sm text-foreground-300 leading-relaxed mt-3 max-w-xs">
              专业的品牌官方平台，提供安全、稳定、高效的品牌数字化服务。让每一个品牌都能在数字世界绽放光彩。
            </p>
            <div className="flex items-center gap-3 mt-5">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-foreground-800 hover:bg-primary-500 transition-colors duration-200 cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line text-base"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-foreground-800 hover:bg-primary-500 transition-colors duration-200 cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line text-base"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-foreground-800 hover:bg-primary-500 transition-colors duration-200 cursor-pointer" aria-label="邮箱">
                <i className="ri-mail-line text-base"></i>
              </a>
            </div>
          </div>

          {/* Link Columns */}
          {Object.entries(footerLinks).map(([title, links]) => (
            <div key={title}>
              <h4 className="text-sm font-semibold text-white mb-4 font-heading tracking-wide">
                {title}
              </h4>
              <ul className="space-y-2.5">
                {links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.path}
                      className="text-sm text-foreground-300 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Bottom Bar */}
        <div className="mt-14 pt-8 border-t border-foreground-700/50 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-400">
            &copy; {new Date().getFullYear()} 问鼎.cc 版权所有 | 保留一切权利
          </p>
          <div className="flex items-center gap-6">
            <a href="#" className="text-xs text-foreground-400 hover:text-foreground-200 transition-colors whitespace-nowrap">隐私政策</a>
            <a href="#" className="text-xs text-foreground-400 hover:text-foreground-200 transition-colors whitespace-nowrap">服务条款</a>
            <a href="#" className="text-xs text-foreground-400 hover:text-foreground-200 transition-colors whitespace-nowrap">网站地图</a>
          </div>
        </div>
      </div>
    </footer>
  );
}